import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./reducers/authReducer";
import generalReducer from "./reducers/generalReducer";
import jobDataReducer from "./reducers/jobDataReducer";
import registrationReducer from "./reducers/registrationReducer";
import onboardingReducer from "./reducers/onboardingReducer";

const store = configureStore({
  reducer: {
    jobData: jobDataReducer,
    auth: authReducer,
    registration: registrationReducer,
    onboarding: onboardingReducer,
    generalStates: generalReducer
  },
});

export default store;
